// @flow

/**
 * Shared display wrapper component
 */

import styled from 'styled-components';

// data-display-id attribute is set dynamically via props for export capture
const DisplayWrapper = styled.div.attrs(props => ({
  'data-display-id': props.$displayId || undefined,
}))`
  margin: 0.75rem 0;
  padding: 1rem;
  border: 1px solid rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  background: white;
  overflow: hidden;
  min-width: 0;
  max-width: 100%;
`;

export default DisplayWrapper;
